import { API_URL } from "../service.config";
import info from "../../utils/info";

export default {
  createService(service: any) {
    return API_URL.post(`/service`, service, {
      headers: {
        Authorization: `Bearer ${info.getToken()}`
      }
    });
  },
  updateService(service: any) {
    return API_URL.put(`/service`, service, {
      headers: {
        Authorization: `Bearer ${info.getToken()}`
      }
    });
  },
  deleteService(serviceID: string) {
    return API_URL.delete(`/service/${serviceID}`, {
      headers: {
        Authorization: `Bearer ${info.getToken()}`
      }
    });
  },
  getServices(pagination: any) {
    return API_URL.get(
      `/service?site=admin&start=${pagination.start}&quantity=${pagination.quantity}`,
      {
        headers: {
          Authorization: `Bearer ${info.getToken()}`
        }
      }
    );
  },
  getServicesToClient(pagination: any) {
    return API_URL.get(
      `/service?start=${pagination.start}&quantity=${pagination.quantity}`
    );
  }
};
